export default "/build/images/aero-score-b.d0a4800f.png";